/* eslint-disable no-undef */
(function() {
	//this directive is used only for previewing the widget in fob.com

	angular.module('meanApp').controller('ingredientCtrl', ingredientCtrl);

	ingredientCtrl.$inject = [
		'$location',
		'$state',
		'$scope',
		'ingredientsManager',
		'context',
		'nutritionService',
		'tagService',
		'colors',
		'$sce',
		'$compile'
	];
	function ingredientCtrl(
		$location,
		$state,
		$scope,
		ingredientsManager,
		context,
		nutritionService,
		tagService,
		Colors,
		$sce,
		$compile
	) {
		var vm = this;
		var NUTRIENTS_WHITELIST_IDS = [ 291, 203, 208, 606, 307, 269 ];
		//console.log('the current user is ', $rootScope.currentUser);
		vm.ingredient = {};
		vm.interactions = {};
		vm.sliderOpen = false;
		vm.nutriscoreLetter = 'C'; //default for waiting the real result
		console.log($state.params.slug);

		vm.widgetPreviewOptions = {
			image: true,
			nutriscore: true,
			monthProduction: true,
			goodThings: true,
			badThings: true,
			nutritags: true
		};

		var date = new Date();
		vm.bulletLeft = parseInt(100 * (date.getMonth() * 29.5 + date.getDate()) / 366);
		vm.resetContext = function() {
			var actions = [
				{
					iconName: 'heart-o',
					actionTitle: 'Miam!' + (vm.interactions.isLiked ? ' ✔' : ''),
					dropdownActionCallback: function() {
						vm.onLikeIngredient();
					}
				},
				{
					iconName: 'dead',
					actionTitle: 'Beurk!' + (vm.interactions.isDisliked ? ' ✔' : ''),
					dropdownActionCallback: function() {
						vm.ondislikeIngredient();
					}
				},
				{
					iconName: 'widget',
					actionTitle: 'Widget',
					dropdownActionCallback: function() {
						vm.goToWidgetisation();
					}
				}
			];

			if (navigator && navigator.share) {
				actions.push({
					iconName: 'share',
					actionTitle: 'Partager',
					dropdownActionCallback: function() {
						navigator.share({
							title: vm.ingredient.name,
							url: document.URL,
							text: vm.ingredient.name + ' : Toutes les infos nutritionnelles sur Fraiseoubacon.com :)'
						});
					}
				});
			}

			context.set({
				title : vm.ingredient.name + ": toutes ses informations nutritionnelles",
				dropDownActions: actions,
				colorBackground: vm.ingredient.hexDominantColor
			});
		};

		console.log('ingreident controller, before the ingredientsmanager call');
		//this forces the call normally TODO optimize and cache if the call had already been made
		ingredientsManager.get($state.params.slug, true).then(
			function(result) {
				result.nutrientsQuantity = result.nutrientsQuantity.filter(function(nutrientsQuantity) {
					return (
						nutrientsQuantity.nutrient &&
						nutrientsQuantity.nutrient._id &&
						NUTRIENTS_WHITELIST_IDS.indexOf(nutrientsQuantity.nutrient._id) > -1
					);
				});

				vm.ingredient = result;
				vm.typedIngredient = vm.ingredient.name;
				context.set({
					contextName: result.name,
					title : result.name + ": toutes ses informations nutritionnelles",
					//iconAction : 'heart-o',
					//iconCallback : vm.onClickHeartNavbar,
					colorBackground: vm.ingredient.hexDominantColor
				});

				parseIngredient(vm.ingredient);
				setMonths(vm.ingredient);
				vm.nutriscoreLetter = vm.ingredient.getNutriscoreLetter();

				//retrieve the interactions, when we are in callback make the buttons available again
				vm.ingredient.getInteractions().then(
					function(data) {
						vm.interactions = data;
						vm.resetContext();
						console.log('the api interactions on ingredient succeeded', data);
					},
					function() {
						console.log('the api like on ingredient failed');
					}
				);
			},
			function(err) {
				console.log('error loading the ingredient', err);
			}
		);

		vm.goodThings = [];
		vm.badThings = [];
		vm.monthsProduction = [];

		var setMonths = function(ingredient) {
			var monthsProduced = ingredient.monthsSoldInFrance,
				monthsSmartPercentage = [],
				goodColor = '#29894d',
				badColor = '#BBBBBB', //'#ef8303',
				colorStatus = monthsProduced.indexOf(0) > -1 ? goodColor : badColor,
				newColorStatus,
				percentageIncrease = 100 / 12,
				percentage = 0, //init percentage
				isProduced;

			for (var i = 0, l = 12; i < l; i++) {
				console.log('index is ', i);
				isProduced = monthsProduced.indexOf(i) > -1;
				newColorStatus = isProduced ? goodColor : badColor;
				vm.monthsProduction.push(isProduced);
				percentage += percentageIncrease;
				monthsSmartPercentage.push({
					color: newColorStatus,
					percentage: percentage
				});
			}

			var cssStyleLinear = 'linear-gradient( to right, ',
				commar = '';

			monthsSmartPercentage.forEach(function(itemSmart, index) {
				commar = index === 0 ? '' : ',';
				cssStyleLinear += commar + ' ' + itemSmart.color + ' ' + itemSmart.percentage + '%';
			});

			cssStyleLinear += ')';
			vm.timelineStyle = cssStyleLinear;
		};

		//level colors 1 great, 2, good, 3, bad, 4 very bad
		var parseIngredient = function(ingredient) {
			//1 take every ingredient and push it in the bad or good section, or neither one nor the other
			console.log(ingredient);
			//console.log('color to hsl is', hexToHSL(ingredient.hexDominantColor));

			//take the closest color available
			//ingredient.hexDominantColor = Colors.getClosestColorPossible(ingredient.hexDominantColor);//hexToHSL(ingredient.hexDominantColor);
			ingredient.hexDominantColorAlpha = Colors.hexToHSLLighter(ingredient.hexDominantColor, 70);
			ingredient.linearStyle =
				'linear-gradient(to right top, ' +
				ingredient.hexDominantColor +
				' 40%, ' +
				ingredient.hexDominantColorAlpha +
				' 100%)';

			//vm.recipe.hexDominantColor = Colors.getClosestColorPossible(vm.recipe.hexDominantColor);

			if (ingredient.price < 5) {
				vm.goodThings.push({
					name: 'Economique',
					description: 'Ce produit est économique',
					level: 1,
					iconName: 'fob-moneybox'
				});
			}

			//push local and fruits/legumes
			ingredient.features.forEach(function(feature) {
				if (feature.easyID === 8) {
					vm.goodThings.push({
						name: 'Local',
						description: 'Ce produit peut provenir de France métropolitaine',
						level: 1,
						iconName: 'fob-crosshair'
					});
				}
			});

			if (ingredient.percentageFruitsAndVegetables > 80) {
				vm.goodThings.push({
					name: 'Fruits & Légumes',
					description: 'Ce produit contient plus de 80% de fruits et légumes',
					level: 1,
					iconName: 'fob-carrot-and-apple'
				});
			}

			var infoGoodAndBad = nutritionService.getGoodAndBadThings(ingredient.nutrientsQuantity);
			vm.goodThings = vm.goodThings.concat(infoGoodAndBad.goodThings);
			vm.badThings = vm.badThings.concat(infoGoodAndBad.badThings);
		};

		vm.onPanDown = function(event) {
			console.log('pan down detected', event);
			/**if (event.srcEvent && event.srcEvent.stopPropagation) {
			console.log('will stope event propagation pan up');
			//event.gesture.preventDefault();
			event.srcEvent.preventDefault();
			event.srcEvent.stopPropagation();
		}**/

			var element = event.element;
			console.log('the parent div', element.parent());
			//console.log('pan down scroll position event scroll top', element.parent()[0].scrollTop);
			//console.log('pan down scroll position event scroll top', element.scrollTop());
			if (element.parent()[0].scrollTop !== 0) {
				return false;
			}

			if (event.isFinal) {
				console.log('final event');
				//here we have two options, whether take it back to the normal position
				if (Math.abs(event.deltaY) > 10) {
					//element.parent().removeClass('slider-open');
					vm.onSliderToggle();
				}
				//element.css('transform', 'translateY(0px)');
			} else {
				//element.css('transform', 'translateY(' +event.deltaY+'px)');
			}
		};

		vm.onPanUp = function(event) {
			if (vm.sliderOpen) {
				/**do not listen to this event when slide is open, we don't need that*/
				return false;
			}
			console.log('pan up detected', event);
			//alert('pan up detected');
			//NotE : if domevents activated we got an element nodejs otherwise a Jquery node
			var element = event.element;
			/**if(element.parent().hasClass('slider-open')) {
			console.log('on pan up is false');
			return false;
		}**/
			//if(event.isFinal) {
			vm.onSliderToggle();
			return false;
			//alert('pan up final');
			//here we have two options, whether take it back to the normal position
			/**if(Math.abs(event.deltaY) > 10 ) {
				vm.onSliderToggle();
				return false;
				//element.parent().addClass('slider-open');
			}**/
			//element.css('transform', 'translateY(0px)');
			//second option expand the container
			//}
			/*else {
			//element.css('transform', 'translateY(' +event.deltaY+'px)');
		}*/
		};

		vm.onPanEnd = function(event) {
			var selector = event.deltaX > 0 ? 'heart-container' : 'yurk-container',
				element = angular.element(document.getElementsByClassName(selector)[0]),
				maxSwipeDetectionReach = 70;

			if (Math.abs(event.deltaX) >= maxSwipeDetectionReach) {
				/*var contextInstance = context.get();
			context.set({
				iconAction: (event.deltaX > 0) ? 'heart' : 'heart-o'
			});*/
				element.css(
					'transition',
					'opacity 2000ms cubic-bezier( 0.5, 0, 0.5, 1 ), display 5000ms cubic-bezier( 0.5, 0, 0.5, 1 )'
				);
				element.css('opacity', 0);
				setTimeout(function() {
					element.css('display', 'none');
				}, 2000);
			} else {
				element.css('display', 'none');
			}
		};

		vm.onPanCancel = function(event) {
			var selector = event.deltaX > 0 ? 'heart-container' : 'yurk-container',
				element = angular.element(document.getElementsByClassName(selector)[0]);
			element.css('display', 'none');
		};

		vm.onPanStart = function(event) {
			/**if(event.pointerType == 'touch' && (Math.abs(event.deltaY) > Math.abs(event.deltaX))){ 
			console.log('pan start cancelled');
			return false; 
		}**/

			var selector = event.deltaX > 0 ? 'heart-container' : 'yurk-container',
				element = angular.element(document.getElementsByClassName(selector)[0]);
			element.css('transition', '');
			element.css('display', 'flex');
		};

		vm.onPanRight = function(event) {
			/**if(event.pointerType == 'touch' && (Math.abs(event.deltaY) > Math.abs(event.deltaX))){ 
			console.log('pan right cancelled');
			return false; 
		}**/

			var element = angular.element(document.getElementsByClassName('heart-container')[0]),
				maxSwipeDetectionReach = 70; //value in pixel

			if (event.deltaX > maxSwipeDetectionReach) {
				element.css('opacity', 1);
			} else {
				element.css('opacity', Math.round(10 * event.deltaX / maxSwipeDetectionReach) / 10);
			}

			if (event.isFinal === true) {
				vm.onPanEnd(event);
			}
		};

		vm.onPanLeft = function(event) {
			/**if(event.pointerType == 'touch' && (Math.abs(event.deltaY) > Math.abs(event.deltaX))){ 
			console.log('pan left cancelled');
			return false; 
		}**/

			var element = angular.element(document.getElementsByClassName('yurk-container')[0]),
				maxSwipeDetectionReach = 70,
				deltaXAbs = Math.abs(event.deltaX);

			if (deltaXAbs > maxSwipeDetectionReach) {
				element.css('opacity', 1);
			} else {
				element.css('opacity', Math.round(10 * deltaXAbs / maxSwipeDetectionReach) / 10);
			}

			if (event.isFinal === true) {
				vm.onPanEnd(event);
			}
		};

		var activateNumbers = function() {
			//1- find all the data-odometer-value
			var value, od;
			document.querySelectorAll('.nutrition-fact-quantity').forEach(function(nodeEl) {
				value = nodeEl.getAttribute('data-odometer-value');
				if (Odometer) {
					od = new Odometer({
						el: nodeEl,
						value: 0,
						format: '( ddd),d',
						theme: 'default'
					});
					od.update(value);
				}
			});
		};

		vm.triggerOdometer = function() {
			setTimeout(activateNumbers, 1500);
		};
		vm.onSliderToggle = function() {
			vm.sliderOpen = !vm.sliderOpen;
			vm.triggerOdometer();
		};

		vm.onLikeIngredient = function() {
			if (vm.interactions.isLiked) {
				vm.ingredient.unlike();
			} else {
				vm.interactions.isDisliked = false;
				vm.ingredient.like();
			}
			vm.interactions.isLiked = !vm.interactions.isLiked;
			vm.resetContext(); //reset the context for mobile
		};

		vm.ondislikeIngredient = function() {
			if (vm.interactions.isDisliked) {
				vm.ingredient.undislike();
			} else {
				vm.interactions.isLiked = false;
				vm.ingredient.dislike();
			}
			vm.interactions.isDisliked = !vm.interactions.isDisliked;
			vm.resetContext(); //reset the context for mobile
		};

		vm.absoluteRef = function(id) {
			return 'url(' + $location.absUrl() + '#' + id + ')';
		};

		vm.getWidgetData = function() {
			var widgetData = {
				_id: vm.ingredient._id,
				name: vm.ingredient.name,
				price: vm.ingredient.price,
				slug: vm.ingredient.slug,
				hexDominantColor: vm.ingredient.hexDominantColor,
				percentageFruitsAndVegetables: vm.ingredient.percentageFruitsAndVegetables,
				nutrientsQuantity: vm.ingredient.nutrientsQuantity.map(function(nutrientQuantity) {
					//return a cleaned and lighter structure for the widget
					return {
						nutrient: {
							_id: nutrientQuantity.nutrient._id,
							unit: nutrientQuantity.nutrient.unit
						},
						quantity: nutrientQuantity.quantity
					};
				}),
				monthsSoldInFrance: vm.ingredient.monthsSoldInFrance,
				//features : vm.ingredient.features,
				nutriscoreLetter: vm.ingredient.nutriscoreLetter,
				tagNames: vm.ingredient.getTagNames()
			};
			//here reduce the amount od data passed
			return JSON.stringify(widgetData);
		};

		vm.getTagTranslated = function(tag) {
			return tagService.wording[tag];
		};

		/**vm.widgetPreviewOptions = {
		'image' : true,
		'nutriscore': true,
		'monthProduction': true,
		'goodThings': true,
		'badThings' : true,
		'nutritags' : true
	};**/

		vm.getClassesToHide = function() {
			var classes = '';
			if (vm.widgetPreviewOptions.image === false) {
				classes += 'aa ';
			}
			if (vm.widgetPreviewOptions.nutriscore === false) {
				classes += 'bb ';
			}
			if (vm.widgetPreviewOptions.monthProduction === false) {
				classes += 'cc ';
			}
			if (vm.widgetPreviewOptions.goodThings === false) {
				classes += 'dd ';
			}
			if (vm.widgetPreviewOptions.badThings === false) {
				classes += 'ee ';
			}
			if (vm.widgetPreviewOptions.nutritags === false) {
				classes += 'ff ';
			}
			//vm.classes= classes;
			return classes;
		};

		vm.onCopyInClipboard = function() {
			navigator.clipboard.writeText(vm.getCodeToSelect()).then(
				function() {
					vm.copyButtonClicked = true;
				},
				function() {
					//note n°3 : if this fails (like on safari for instance... :( ) may be fallback here on the old execCommand API
				}
			);
		};

		vm.getCodeToSelect = function() {
			var domain = document.location.origin;
			return $sce.trustAsHtml(
				`<div class='` +
					vm.getClassesToHide() +
					`' ng-app="meanApp" id="fob-widget" ng-controller="ingredientWidgetCtrl" widget-data='` +
					vm.getWidgetData() +
					`'>Infos nutritionnelles</div><script type="text/javascript" src="` +
					domain +
					`/ing.w1.js"></script>`
			);
		};

		vm.triggerCodePreview = function() {
			//1- we need to load the ingredient-nutrition widget file
			var domain = document.location.origin;
			vm.loadScript(domain + '/widget/ingredient-nutrition.js', function() {
				var widgetEl = angular.element(document.getElementById('fob-widget'));
				$compile(widgetEl.contents())($scope);
			});
		};

		vm.onPreviewChange = function() {
			//vm.getCodeToSelect();
			var widgetEl = angular.element(document.getElementById('fob-widget'));
			$compile(widgetEl.contents())($scope);
		};

		//TODO to be moved in a utils
		vm.loadScript = function(url, callback) {
			if (url) {
				var script = document.querySelector("script[src*='" + url + "']");
				//if (!script) {
					var heads = document.getElementsByTagName('head');
					if (heads && heads.length) {
						var head = heads[0];
						if (head) {
							script = document.createElement('script');
							script.setAttribute('src', url);
							script.setAttribute('type', 'text/javascript');
							script.onload = function() {
								callback && callback();
							};
							script.onerror = function() {
								callback && callback();
							};
							//if (charset) script.setAttribute('charset', charset);
							head.appendChild(script);
						}
					}
				//}
				return script;
			}
		};

		vm.goToWidgetisation = function() {
			$state.go('ingredientWidget', {
				slug: vm.ingredient.slug
			});
		};

		vm.ingredientsSearchResult = function(ingredientName) {
			vm.ingredientSelectedBackupName = ingredientName;
			//here return a promise
			return ingredientsManager.searchAutocomplete(ingredientName).then(
				function(results) {
					console.log('results of ingredient search', results);
					//only push if at least one result
					/*if(results.length > 0) {
				results.push({
					word: WORDING_FOR_THE_NON_RELEVANT_INGREDIENT,
					data : [WORDING_FOR_THE_NON_RELEVANT_INGREDIENT]
				});
			}*/
					//add here a non matched result
					return results;
				},
				function(err) {
					console.log('erreur loading all profiles');
					console.log(err);
				}
			);
		};

		vm.typeaheadOnSelect = function(item) {
			//here perform a call to the back end and get more info about this ingredient
			var slugOfIngredient = item.data[0];
			vm.goodThings = [];
			vm.badThings = [];
			vm.monthsProduction = [];
			ingredientsManager.get(slugOfIngredient, true).then(
				function(result) {
					result.nutrientsQuantity = result.nutrientsQuantity.filter(function(nutrientsQuantity) {
						return (
							nutrientsQuantity.nutrient &&
							nutrientsQuantity.nutrient._id &&
							NUTRIENTS_WHITELIST_IDS.indexOf(nutrientsQuantity.nutrient._id) > -1
						);
					});

					vm.ingredient = result;

					parseIngredient(vm.ingredient);
					setMonths(vm.ingredient);
					vm.nutriscoreLetter = vm.ingredient.getNutriscoreLetter();
				},
				function() {
					console.log('error loading the ingredient');
				}
			);
		};
	}
})();
